import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunk from 'redux-thunk';
import authReducer from '../reducers/auth';
import cssReducer from '../reducers/css';
import productReducer from '../reducers/product';
import cartReducer from '../reducers/cart';
import adminReducer from '../reducers/admin';
import filterSearchReducer from '../reducers/filterSearch';
import notificationReducer from '../reducers/notifications';
import setPagCountReducer from '../reducers/searchPagination';
import adsModalReducer from '../reducers/adsModal';
import whatsAppCartReducer from '../reducers/WhatsAppCart';

export default () => createStore(
  combineReducers({
    auth: authReducer,
    css: cssReducer,  
    product: productReducer,
    cart: cartReducer, 
    admin: adminReducer,   
    filterSearch: filterSearchReducer,
    notifications: notificationReducer,
    pagCount: setPagCountReducer,
    adsModal: adsModalReducer,
    whatsAppCart: whatsAppCartReducer,
}), applyMiddleware(thunk));

